import React, { Component } from "react";
import service from "../../core/service";

interface IProps {
  dispatch?: any;
  userData?: any;
  dashboardData:any;
}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any;
  value: string;
  openActionModal: boolean;
  loading: boolean;
  clickLoading: boolean;
  transactionsList: any;
  page: number;
  number: any;
  plan_type: string;
  uploadLoading: boolean;
  descr: string;
  count: string;
  debounceTimeout: any;
}

export class TransactionsController extends Component<IProps, IState> {
  arrowRef: any;
  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    debounceTimeout: null, 
    clickLoading: false,
    count: "",
    str: "",
    anchorEl: null,
    open: false,
    value: "",
    openActionModal: false,
    loading: false,
    transactionsList: [],
    page: 1,
   
    number: "",
    plan_type: "",
    uploadLoading: false,
    descr: "",
  };
  id: any = this.state.open ? "simple-popper" : undefined;

  debounceApiCall = (shareHolder: number) => {
    if (this.state.debounceTimeout) {
      clearTimeout(this.state.debounceTimeout);
    }

    const timeout = setTimeout(() => {
      // this.createPreFactor(shareHolder);
    }, 500);

    this.setState({ debounceTimeout: timeout });
  };

  handleChange = (e: any) => {
    this.setState({ value: e.target.value });
  };

  getList = async (): Promise<void> => {
    // this.setState({ loading: true });
    const { page, count } = this.state;

    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "10",
    };

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        params.append(key, value);
      }
    }

    try {
      const response = await service.Payment.list(page);
      if (response) {
        this.setState({ transactionsList: response?.data?.data, loading: false });
        // this.setState({ openModal: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };



  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value });
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getList();
    }, 800);
  };

  
}

export default TransactionsController;
